module.exports = __webpack_public_path__ + "static/screen-web-win-laptop-c108c9ac0134ff4478c0a88dbd2876d2.webp";